import { dataLayer } from "@/app/infrastructures/misc/UtilsGtm";

export const GTMBookingCargoEvent = (eventName: string, custom = {}) => {
  dataLayer(eventName, custom, ["userType", "userId", "username"]);
};
